export default "__VITE_ASSET__Pxc_fI5t__"